export default __webpack_public_path__ + "media/zurb/img/legacy/strike/strike-large-d48dd1f75b2ac48d05788a2ce5c862b8.png";